import type { InsertDepartmentTypeGroupByNameMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDepartmentTypeGroupByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { CreateDepartmentTypeGroupInput } from './types';

export const useInsertDepartmentTypeGroupByName = createMutationHook({
  name: 'insertDepartmentTypeGroupByName',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.department.insertTypeGroupByName.mutationOptions({
      onSuccess,
    }),
  mapInput: (variables: CreateDepartmentTypeGroupInput): { Name: string } => {
    if (!variables.Name) {
      throw new Error('Name is required');
    }

    return { Name: variables.Name };
  },
  invalidate: (trpc) => [
    trpc.frontend.department.departmentTypeGroups.queryKey(),
  ],
  mapResponse: (result: {
    Id: string;
  }): InsertDepartmentTypeGroupByNameMutation => ({
    insert_department_type_group_one: {
      __typename: 'department_type_group',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertDepartmentTypeGroupByNameDocument,
  graphqlVariables: (variables: CreateDepartmentTypeGroupInput) => ({
    ...variables,
  }),
  evictFields: ['department_type_group'],
});
